import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import Swal from 'sweetalert2';
import { api } from "api";

const SUBMIT = 'FASE_SUBMIT';
const LOADER = 'FASE_LOADER';
const DATA = "FASE_DATA";
const FILTER = "FILTER_DATA";

const ENDPOINT = "fase_proyecto"

export const constants = {
    SUBMIT,
};

// ------------------------------------
// Pure Actions
// ------------------------------------

export const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const setData = data => ({
    type: DATA,
    data
})

export const setFilter = filter => ({
    type: FILTER,
    filter
})

// ------------------------------------
// Actions
// ------------------------------------

export const onSubmit = (data = {}) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    api.post(`${ENDPOINT}`, data).then((response) => {
        Swal.fire({
            title: 'Éxito',
            text: 'Se ha guardado correctamente',
            type: 'success',
        })
        dispatch(push("/fases-proyecto"));
    }).catch(() => {
        Swal.fire({
            title: 'Error',
            text: 'Ha ocurrido un error, inténtelo nuevamente.',
            type: 'error',
        })
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const listar = (params={}) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${ENDPOINT}`, params).then(response => {
        dispatch(setData(response));
    }).catch(() => {
        // Manejar errores si es necesario
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


export const obtenerFase = (id=null) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${ENDPOINT}/${id}`).then(response => {
        dispatch(initializeForm('CrearEditarForm', response));
    })
        .catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actualizarFase = (data={}, id=null) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${ENDPOINT}/${id}`, data).then(response => {
        Swal.fire({
            title: 'Éxito',
            text: 'Se ha actualizado correctamente',
            type: 'success',
        })
        dispatch(push("/fases-proyecto"));
    }).catch(() => {
        Swal.fire({
            title: 'Error',
            text: 'Ha ocurrido un error, inténtelo nuevamente.',
            type: 'error',
        })
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actualizarOrden = (data={}) => (dispatch) => {
    dispatch(setLoader(true));
    api.post(`${ENDPOINT}/update_order`, {fases: data}).then(response => {
        Swal.fire({
            title: 'Éxito',
            text: 'Se ha actualizado correctamente',
            type: 'success',
        })
        dispatch(push("/fases-proyecto"));
    }).catch(() => {
        Swal.fire({
            title: 'Error',
            text: 'Ha ocurrido un error, inténtelo nuevamente.',
            type: 'error',
        })
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const eliminar = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`${ENDPOINT}/${id}`).then(() => {
        Swal.fire({
            title: 'Éxito',
            text: 'Se ha eliminado correctamente',
            type: 'success',
        })
    })
        .catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const getMe = () => (dispatch) => {
    api.get('/user/me').then(me => {
        dispatch(initializeForm('profile', me));
        dispatch(setMe(me));
    })
        .catch(() => {
    }).finally(() => {});
};

export const obtenerFilterList = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${ENDPOINT}/filter_list`).then(response => {
        dispatch(setFilter(response));
    })
        .catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


export const actions = {
    listar,
    eliminar,
    onSubmit,
    obtenerFase,
    actualizarFase,
    actualizarOrden,
    obtenerFilterList,
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [FILTER]: (state, { filter }) => {
        return {
            ...state,
            filter,
        };
    },
};

export const initialState = {
    loader: false,
    data: false,
    filter: [],
};

export default handleActions(reducers, initialState);
